var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import { connect } from "react-redux";
import { selectModalTabId } from "../../selectors/selectModalTabId";
import { IdModal } from "../modals/IdModal";
import { actionCoopXpRankRequest, actionPlayerXpRankRequest } from "./actionRanking";
import { PlayerRankingCategory } from "./PlayerRankingCategory";
export var HOCRanking = function (RankingComponent) {
    var WithRankingRequest = /** @class */ (function (_super) {
        __extends(WithRankingRequest, _super);
        function WithRankingRequest() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.getRankingRequest = function () {
                var _a = _this.props, activeTabIndex = _a.activeTabIndex, playerXpRankingRequest = _a.playerXpRankingRequest, coopXpRankingRequest = _a.coopXpRankingRequest;
                switch (activeTabIndex) {
                    case PlayerRankingCategory.CoopLevelRanking:
                        return coopXpRankingRequest;
                    case PlayerRankingCategory.PlayerLevelRanking:
                    default:
                        return playerXpRankingRequest;
                }
            };
            return _this;
        }
        WithRankingRequest.prototype.render = function () {
            var rankingRequest = this.getRankingRequest();
            return (React.createElement(RankingComponent, __assign({}, this.props, this.state, { onRankingRequest: rankingRequest })));
        };
        return WithRankingRequest;
    }(React.Component));
    var mapState = function (state) { return ({
        activeTabIndex: selectModalTabId(state, IdModal.PlayerRanking),
    }); };
    var mapDispatch = function (dispatch) { return ({
        coopXpRankingRequest: function (nameSearch, position) {
            return dispatch(actionCoopXpRankRequest(nameSearch, position));
        },
        playerXpRankingRequest: function (nameSearch, position) {
            return dispatch(actionPlayerXpRankRequest(nameSearch, position));
        },
    }); };
    return connect(mapState, mapDispatch)(WithRankingRequest);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/ranking/HOCRanking.tsx
// module id = 444
// module chunks = 3